import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';
import type { WorkQueueListResponse } from '@/types/workQueue';

export type WorkQueueQuery = {
  scope?: 'ALL' | 'MY' | 'TEAM';
  module?: string;
  priority?: string;
  bucket?: string;
  status?: string;
  executive?: boolean;
};

export const workQueueApi = {
  list: (params?: WorkQueueQuery) =>
    unwrap(api.get<ApiResponse<WorkQueueListResponse>>('/v1/work-queue', { params })),

  executeAction: (sourceType: string, sourceId: number, action: string, notes?: string) =>
    unwrap(
      api.post<ApiResponse<null>>(`/v1/work-queue/items/${sourceType}/${sourceId}/actions`, {
        action,
        notes,
      }),
    ),
};
